import {
  withDefaultContextAsSelectedProjectDocChat,
  withDefaultContextAsSelectedProject,
} from './api-default-context';
import { PROCESS_TYPES } from 'components/feature/toolkit/chatbot-toolkit-panel/toolkit-chatbot-utils';
import { getDocChatHeaders } from 'api/docChat-api-client';

export const sendChatBotUserResponse = async ({ userResponse }) => {
  const docChatHeaders = await getDocChatHeaders();

  return withDefaultContextAsSelectedProjectDocChat()
    .post('/api/chat/chat_message/', userResponse, {
      headers: docChatHeaders,
    })
    .then((response) => {
      return response.data; // Return the response data
    })
    .catch((error) => {
      throw error; // Re-throw the error to be handled by the caller
    });
};

export const submitChatbotResponseFeedback = async (requestparams) => {
  const docChatHeaders = await getDocChatHeaders();

  return withDefaultContextAsSelectedProjectDocChat()
    .post('/api/chat/submit_feedback/', requestparams, {
      headers: docChatHeaders,
    })
    .then((response) => {
      return response.data; // Return the response data
    })
    .catch((error) => {
      throw error; // Re-throw the error to be handled by the caller
    });
};

export const getDocumentIndexingStatus = async (fileKey) => {
  return withDefaultContextAsSelectedProject()
    .get(`/tieout/doc-chat/details/${fileKey}`)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      throw error;
    });
};

export const getDocumentIndexingStatusBasedOnProcessType = async (fileKey) => {
  return withDefaultContextAsSelectedProject()
    .get(
      `/tieout/doc-chat/file-key/${fileKey}/process-type/${PROCESS_TYPES.INDEXING}`,
    )
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      throw error;
    });
};

export const getPromptsLibrary = async (params) => {
  const docChatHeaders = await getDocChatHeaders();
  return withDefaultContextAsSelectedProjectDocChat()
    .post('/api/chat/prompts', params, {
      headers: docChatHeaders,
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      throw error;
    });
};

export const startDocumentIndexing = async (requestparams) => {
  return withDefaultContextAsSelectedProject()
    .post('/tieout/doc-chat/reindex', requestparams)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      throw error;
    });
};

export const getChatBotFeatureFlagsByClientId = async ({ chatBotFeatureFlags, clientId }) => {
  const apiPromises = chatBotFeatureFlags.map(featureFlag => 
    withDefaultContextAsSelectedProject()
      .get(`/tieout/features/${featureFlag}/clients/${parseInt(clientId)}/flags`)
      .then((response) => ({
        featureFlag,
        data: response.data,
        success: true
      }))
      .catch((error) => ({
        featureFlag,
        error: error.message || error,
        success: false
      }))
  );
  
  const results = await Promise.all(apiPromises);
  
  // Check if all API calls failed
  const allFailed = results.every(result => !result.success);
  
  if (allFailed) {
    return []; // Return empty array if all calls fail
  }
  
  // Return partial results - successful data and empty objects for failures
  const combinedResponse = {
    featureFlags: results.reduce((acc, result) => {
      acc[result.featureFlag] = result.success ? result.data : {};
      return acc;
    }, {})
  };
  
  return combinedResponse;
};
